import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiBox, MiDetailFields, MiSectionHeader } from "@miplatform/components";
import { INPUT_TYPES } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { useSpecDetailFormViewModel } from "./useSpecDetailFormViewModel";

export function SpecDetailForm({ stateManager, control, setValue }) {
  const {
    params: { accountId, seriesOrCommunityId },
  } = useRouter();
  const { classes } = useStyles();
  const {
    customerOptions,
    seriesOptions,
    specLevelOptions,
    getCustomerOptions,
    getSeriesOptions,
  } = useSpecDetailFormViewModel({ stateManager, setValue });

  useEffect(() => {
    getCustomerOptions();
    getSeriesOptions(accountId, seriesOrCommunityId);
  }, []);

  const specPlanField = [
    {
      fieldType: INPUT_TYPES.SELECT,
      label: "Customer",
      name: "builderId",
      formControl: control,
      options: customerOptions,
      required: true,
      disabled: true,
      width: "50%",
    },
    {
      fieldType: INPUT_TYPES.SELECT,
      label: "Series",
      name: "seriesId",
      formControl: control,
      required: true,
      options: seriesOptions,
      width: "50%",
      disabled: true,
    },
    {
      fieldType: INPUT_TYPES.SELECT,
      label: "Spec Level",
      name: "specLevel",
      formControl: control,
      options: specLevelOptions,
      width: "50%",
      disabled: true,
    },
    {
      label: "Bid Name",
      name: "name",
      formControl: control,
      required: true,
      width: "50%",
    },
  ];

  return (
    <MiBox height="100%" overflow="auto">
      <MiSectionHeader
        title="Enter Bid Details"
        subtitle="Enter all the details required"
      />
      <MiDetailFields
        detailFields={specPlanField}
        customWrapperStyle={classes.specPlanFieldContainer}
      />
    </MiBox>
  );
}

const useStyles = makeStyles()(() => ({
  specPlanFieldContainer: {
    width: "50%",
  },
}));
